module.exports = __webpack_public_path__ + "img/bg.81cd06ec.svg";